<template>
  <div
    v-loading.fullscreen="loading"
    class="flex justify-center w-full"
    id="app"
  >
    <SvgPanZoom
      v-if="viewBox"
      :controlIconsEnabled="controlIcons"
      :mouseWheelZoomEnabled="true"
      :fit="true"
      :center="true"
      @svgpanzoom="registerSvgPanZoom"
    >
      <svg
        id="map-svg"
        xmlns:svg="http://www.w3.org/2000/svg"
        font-size="130"
        xmlns="http://www.w3.org/2000/svg"
        :height="heightMap"
        :width="widthMap"
        :viewBox="viewBox"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs class="ng-star-inserted">
          <pattern
            id="tile"
            patternUnits="userSpaceOnUse"
            width="309.6"
            height="309.6"
          >
            <polygon
              style="stroke: lightgray; fill: white; stroke-width: 10;"
              :class="[
                activeIndex === index ? 'linkActive' : 'ng-star-inserted'
              ]"
              points="0,0,609.6,0,609.6,609.6,0,609.6"
            />
          </pattern>
        </defs>

        <g id="ground">
          <g id="server-room">
            <template v-for="(item, index) in mapData">
              <polygon
                v-if="item.Type == 'server-room'"
                :key="index + 'server'"
                :class="[
                  activeIndex === index ? 'linkActive' : 'floorItemFrontMaker'
                ]"
                :points="item.Shape"
                fill="url(#tile)"
                fill-opacity="2"
                stroke-width="180"
                stroke="#808080"
              />
            </template>
          </g>
          <g id="floor">
            <template v-for="(item, index) in mapData">
              <rect
                v-if="item.Type === 'perforated-floor-tile'"
                :key="index + 'tile'"
                class="floorItemPerforatedTile"
                :x="item.PositionTopLeftX"
                :y="item.PositionTopLeftY"
                :width="item.Width"
                :height="item.Width"
              />
            </template>
          </g>
          <g
            id="pdu"
            style="
              border-width: 4px;
              stroke: black;
              stroke-width: 10;
              fill: transparent;
            "
          >
            <template v-for="(item, index) in mapData">
              <text
                v-if="item.Type == 'pdu'"
                :key="index + 'pdu'"
                transform="rotate(0,100,100)"
                :x="item.PositionTopLeftX + item.Width / 1"
                :y="item.PositionTopLeftY + item.Height / 4"
                fill="black"
              >
                {{ item.Name }}
              </text>

              <polygon
                v-if="item.Type == 'pdu'"
                :key="item.Id + 'pdu poly'"
                :class="[
                  activeIndex === index ? 'linkActive' : 'floorItemFrontMaker'
                ]"
                :points="item.Shape"
                fill="white"
                fill-opacity="2"
                stroke-width="80"
                stroke="#BDE8A7"
              />
            </template>
          </g>

          <g
            id="generic-equipment"
            style="
              border-width: 4px;
              stroke: black;
              stroke-width: 10;
              fill: transparent;
            "
          >
            <template v-for="(item, index) in mapData">
              <text
                v-if="item.Type == 'generic-equipment'"
                :key="index + 'GE'"
                transform="rotate(0,100,100)"
                :x="item.PositionTopLeftX + (item.Width / 2) * 3"
                :y="item.PositionTopLeftY + item.Height / 4"
                fill="black"
              >
                {{ item.Name }}
              </text>

              <polygon
                v-if="item.Type == 'generic-equipment'"
                :key="item.Id + 'GE'"
                :class="[
                  activeIndex === index ? 'linkActive' : 'floorItemFrontMaker'
                ]"
                :points="item.Shape"
                fill="white"
                fill-opacity="2"
                stroke-width="80"
                stroke="#808080"
              />
            </template>
          </g>

          <g
            id="floorContainer"
            style="border-width: 4px; stroke: black; stroke-width: 10;"
          >
            <template v-for="(item, index) in mapData">
              <polygon
                v-if="item.Type == 'row'"
                :key="index + 'row'"
                :class="[
                  activeIndex === index ? 'linkActive' : 'floorItemFrontMaker'
                ]"
                :points="item.Shape"
                fill="#E0E0D7"
                fill-opacity="2"
                stroke-width="50"
                stroke="rgb(192,192,192)"
              />
            </template>
          </g>
          <g
            id="floorContainer"
            style="border-width: 4px; stroke: black; stroke-width: 10;"
          >
            <template v-for="(item, index) in mapData">
              <polygon
                v-if="item.Type == 'rack'"
                :key="item.Id + 'rack'"
                :class="[
                  activeIndex === index ? 'linkActive' : 'floorItemFrontMaker'
                ]"
                :points="item.Shape"
                fill="white"
                fill-opacity="2"
                stroke-width="50"
                stroke="rgb(192,192,192)"
              />
              <text
                v-if="item.Type == 'rack'"
                :key="index + 'rack'"
                :x="item.PositionTopLeftX + (item.Width / 2) * 3"
                :y="item.PositionTopLeftY + item.Height / 4"
                fill="black"
              >
                {{ item.Name }}
              </text>
            </template>
          </g>
          <g id="insideRack">
            <template v-for="(item, index) in mapData">
              <polygon
                v-if="item.Type == 'inside-rack'"
                :key="index + 'inside-rack'"
                :class="[
                  activeIndex === index ? 'linkActive' : 'floorItemFrontMaker'
                ]"
                :points="item.Shape"
                stroke="hsla(200, 100%,50%,.5)"
                fill="white"
                fill-opacity="2"
                stroke-width="60"
              />
              <template v-if="item.Type == 'inside-rack'">
                <text
                  :key="index + 'bbbinside-rack'"
                  :x="item.PositionTopLeftX + (item.Width / 2) * 3"
                  :y="item.PositionTopLeftY + item.Height / 4"
                  fill="black"
                >
                  {{
                    showHumid == true
                      ? item.SensorDataHumid
                      : item.SensorDataTemp
                  }}
                </text>
              </template>
            </template>
          </g>
          <g id="inRoomCooler">
            <template v-for="(item, index) in mapData">
              <polygon
                v-if="item.Type == 'in-room-cooler'"
                :key="index + 'inroom'"
                :class="[
                  activeIndex === index ? 'linkActive' : 'floorItemFrontMaker'
                ]"
                :points="item.Shape"
                fill="white"
                fill-opacity="2"
                stroke-width="60"
                stroke="hsla(200, 100%,50%,.5)"
              />
              <text
                v-if="item.Type == 'in-room-cooler'"
                :key="item.Id + 'inroom'"
                :x="item.PositionTopLeftX + (item.Width / 3) * 1"
                :y="item.PositionTopLeftY + item.Height / 4"
                fill="black"
              >
                {{ item.Name }}
              </text>
            </template>
          </g>
          <g id="wall">
            <template v-for="(item, index) in mapData">
              <polygon
                v-if="item.Type == 'wall'"
                :key="index + 'wall'"
                :class="[
                  activeIndex === index ? 'linkActive' : 'floorItemFrontMaker'
                ]"
                :points="item.Shape"
                fill-opacity="2"
                stroke-width="60"
                stroke="#808080"
              />
            </template>
          </g>
          <g id="verticalGrille">
            <template v-for="(item, index) in mapData">
              <polygon
                v-if="item.Type == 'vertical-grille'"
                :key="'B' + index"
                :class="[
                  activeIndex === index ? 'linkActive' : 'floorItemFrontMaker'
                ]"
                :points="item.Shape"
                fill="black"
                fill-opacity="2"
                stroke-width="60"
                stroke="#808080"
              />
              <text
                v-if="item.Type == 'vertical-grille'"
                :key="'A' + item.Id"
                :x="item.PositionTopLeftX + 50"
                :y="item.PositionTopLeftY + item.Height / 4"
                fill="black"
              >
                vertical-grille
              </text>
            </template>
          </g>
          <g id="door">
            <template v-for="(item, index) in mapData">
              <polygon
                v-if="item.Type == 'door'"
                :key="index + item.Id"
                :class="[
                  activeIndex === index ? 'linkActive' : 'floorItemFrontMaker'
                ]"
                :points="item.Shape"
                fill="#3A3CF5"
                fill-opacity="2"
                stroke-width="60"
                stroke="#3A3CF5"
              />
            </template>
          </g>
        </g>
      </svg>
      <div v-if="!dashboardPage" class="flex p-4">
        <el-button type="plain" @click="showDataHumid">Humidity</el-button>
        <el-button type="plain" @click="showDataTemp">Temperature</el-button>
      </div>
    </SvgPanZoom>
  </div>
</template>

<script>
import SvgPanZoom from 'vue-svg-pan-zoom'

const width = 2685
const height = 1752
export default {
  name: 'App',
  components: {
    SvgPanZoom
  },
  props: {
    dashboardPage: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default: true
    },
    controlIcons: {
      type: Boolean,
      default: true
    },
    mapData: {
      type: [Array, Object]
    },
    heightMap: {
      type: String,
      default: '650px'
    },
    widthMap: {
      type: String,
      default: '750px'
    },
    sensorData: {
      type: [Array, Object]
    },
    viewBox: {
      type: String,
      default: '0 0 26850 17520'
    },
    activeIndex: {}
  },
  data() {
    return {
      svgpanzoom: null,
      // dataCage: [],
      index: 0,
      configKonva: {
        container: 'container',
        width: width,
        height: height,
        draggable: true
      },
      showHumid: false,
      showTemp: false,
      configLine: {
        points: [
          12366,
          11050,
          12360,
          10250,
          13560,
          10250,
          13560,
          11050,
          12360,
          11050
        ],
        fill: '#00D2FF',
        stroke: 'red',
        strokeWidth: 5,
        closed: true
      },
      configCircle: {
        x: 100,
        y: 100,
        radius: 70,
        fill: 'red',
        stroke: 'black',
        strokeWidth: 4
      }
    }
  },
  destroyed() {
    this.deleteSvg()
  },
  mounted() {
    this.registerSvgPanZoom()
  },
  methods: {
    showDataHumid() {
      this.showHumid = !this.showHumid
      this.showTemp = false
    },
    showDataTemp() {
      this.showTemp = !this.showTemp
      this.showHumid = false
      console.log(this.showTemp)
    },
    zoomButton() {
      this.svgpanzoom.zoomIn()
    },
    zoomOutButton() {
      this.svgpanzoom.zoomOut()
    },
    resetButton() {
      this.svgpanzoom.resetZoom()
    },
    registerSvgPanZoom(svgpanzoom) {
      this.svgpanzoom = svgpanzoom
    },
    deleteSvg() {
      this.svgpanzoom.destroy()
    },
    center() {
      if (!this.svgpanzoom) return

      this.svgpanzoom.center()
    }
  }
}
</script>

<style scoped>
.linkActive {
  fill: #4e8cb1;
  stroke: #b3b3b3;
}

#floorContainer {
  stroke: gray;
}

.floorItemPerforatedTile {
  stroke: grey;
  stroke-width: 10;
  fill: #fafafa;
}

/* .inside-rack polygon {
  fill: #1888b6;
} */

/* g.floorItem:not(.pdu):not(.door) polygon {
  fill: #ffffff;
  opacity: 0.1;
} */

g.floorItemFrontMaker {
  fill: #4e8cb14f;
}

g.floorItem:not(.pdu):not(.door) polygon {
  fill: #4e8db1;
}

g.floorItem:not(.pdu):not(.door) polygon:hover {
  fill: #a2bbc9;
}
g.floorItem:not(.pdu):not(.door) polygon.linkActive {
  fill: #96d0f1;
}

svg {
  cursor: pointer;
}

.wallMeshBorder {
  stroke-dasharray: 150, 50;
  stroke: #b3b3b3;
}
.center-svg {
  display: f;
}
.floorItemPerforatedTile {
  stroke: grey;
  stroke-width: 30;
  fill: #fafafa;
}
</style>
